export default __webpack_public_path__ + "static/media/Snakehead of Intelligence.e2b7bfdd.jpg";